import React, { useState } from "react";
import { ApiService, ImgUrl } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GImageEditor from "../gComponents/gImageEditor";
import { StoreFilter } from "../components/storeFilterComponent";
import { ProductFilter } from "../components/productFilterComponent";
import GButton from "../gComponents/gButton";

const BannerTypes = [
  { title: "Store", value: "store" },
  { title: "Product", value: "product" },
  { title: "Url", value: "url" },
];

export default function BannerForm(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [openSnackbar] = useSnackbar();
  const initialValues = {
    photo: !props.isEmpty ? props.data?.photo : "",
    index: !props.isEmpty ? props.data?.index : "0",
    type: props.type,
    linked_value: !props.isEmpty ? props.data?.linked_value : "",
    linked_type: props.data?.linked_type || "",
    store_id:
      props.data?.linked_type == "product" ? props.data?.value?.store_id : "",
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    console.log(values);
    //return;
    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty
      ? "offer-banners/" + props.data.id
      : "offer-banners";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log("r" + response.status_code);
        if (response.data.status_code === 1) {
          props.setBanvisible(false);
          props.onSubmit();
        }
        openSnackbar(response.data.message);
        setIsBtnDisabled(false);
      }
    );
  };

  const validationSchema = Yup.object({
    photo: Yup.string().required("Required"),
  });

  if (props.banvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Add"} Banner
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <GImageEditor
                onSubmit={(newValue, id) => {
                  values.photo = newValue;
                }}
                id="photo"
                image={
                  values.photo ? `${ImgUrl(props.imgType)}/${values.photo}` : ""
                }
                type={props.imgType}
                style={{ height: "160px", paddingTop: "60px" }}
                divstyle={{ margin: "0 auto", display: "block" }}
                icoStyle={{ marginRight: "10px" }}
                imageStyle={{ width: "95%" }}
              />

              <FormikControl
                control="input"
                type="text"
                name="photo"
                divstyle={{ margin: "0", padding: "0", textAlign: "center" }}
                style={{ display: "none" }}
              />

              <br />
              <FormikControl
                control="input"
                type="text"
                label="Sort Index"
                name="index"
                divstyle={{
                  display: "inline-block",
                  verticalAlign: "top",
                  boxSizing: "border-box",
                  width: "50%",
                }}
              />

              <FormikControl
                control="radio"
                label="Banner Type"
                name="linked_type"
                options={BannerTypes}
                key_title="title"
                key_value="value"
                onChange={(e) => {
                  values.linked_type = e.target.value;
                  setFieldValue("linked_type", e.target.value);

                  values.linked_value = "";
                  setFieldValue("linked_value", "");
                }}
              />

              {values.linked_type == "store" && (
                <div style={{ padding: "4px 15px" }}>
                  <label>Store</label>
                  <StoreFilter
                    value={values.linked_value}
                    title={props.data?.value?.title || ""}
                    storeType={"regular"}
                    style={{
                      marginBottom: "10px",
                      display: "block",
                      width: "100%",
                    }}
                    handleStoreChange={(value) => {
                      console.log(value);
                      setFieldValue("linked_value", value ? value : "");
                    }}
                  />
                </div>
              )}

              {values.linked_type == "product" && (
                <>
                  <div style={{ padding: "4px 15px" }}>
                    <label>Store</label>
                    <StoreFilter
                      value={values?.store_id | ""}
                      title={props.data?.value?.title || ""}
                      storeType={"regular"}
                      style={{
                        marginBottom: "10px",
                        display: "block",
                        width: "100%",
                      }}
                      handleStoreChange={(value) => {
                        console.log(value);
                        setFieldValue("store_id", value || "");
                        setFieldValue("linked_value", "");
                      }}
                    />
                  </div>
                  {values.store_id && values.linked_type == "product" ? (
                    <div style={{ padding: "4px 15px" }}>
                      <label>Product</label>
                      <ProductFilter
                        value={values.linked_value}
                        productTitle={props.data?.value?.title || ""}
                        style={{
                          margin: "0px",
                          width: "100%",
                        }}
                        status={1}
                        containerStyle={{ margin: "0", width: "100%" }}
                        storeId={values.store_id}
                        isStored={values.linked_value ? true : false}
                        perPage={50}
                        handleProductChange={(id, value) => {
                          setFieldValue("linked_value", id ? id : "");
                        }}
                      />{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}

              {values.linked_type == "url" && (
                <FormikControl
                  control="input"
                  type="text"
                  name="linked_value"
                  label="External Url"
                />
              )}

              <br />
              <GButton
                disabled={isBtnDisabled}
                variant="condensed"
                type="submit"
                style={{ margin: "0 15px", width: "calc(100% - 30px)" }}
              >
                {!props.isEmpty ? "Update" : "Create"}
              </GButton>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
